export default "__VITE_ASSET__7846f1e9__"